// extracted by mini-css-extract-plugin
export default {"pipelineBox":"PipelineBox_pipelineBox__I473K","actions":"PipelineBox_actions__a27xc"};